var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProduct = function SvgProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M15.5 7h2.138a2 2 0 0 1 1.995 1.858l.714 10A2 2 0 0 1 18.352 21H6.648a2 2 0 0 1-1.995-2.142l.714-10A2 2 0 0 1 7.362 7H9.5m6 0h-6m6 0V5a3 3 0 1 0-6 0v2m6 5-3.86 3.89a.373.373 0 0 1-.53 0L9.5 14.266"
  })));
};
export default SvgProduct;